export const MEDIA_FRAGMENT = `#graphql
  fragment Media on Media {
    __typename
    mediaContentType
    alt
    previewImage {
      url
    }
    ... on MediaImage {
      id
      image {
        url
        width
        height
        id
      }
    }
    ... on Video {
      id
      sources {
        mimeType
        url
      }
    }
    ... on Model3d {
      id
      sources {
        mimeType
        url
      }
    }
    ... on ExternalVideo {
      id
      embedUrl
      host
    }
  }
`;

export const PRODUCT_CARD_FRAGMENT = `#graphql
  fragment ProductCard on Product {
    id
    title
    vendor
    handle
    descriptionHtml
    options {
      name
      values
    }
    media(first: 3) {
      nodes {
        ...Media
      }
    }
    variants(first: 1) {
      nodes {
        id
        image {
          url
          altText
          width
          height
          id
        }
        price {
          amount
          currencyCode
        }
        compareAtPrice {
          amount
          currencyCode
        }
        selectedOptions {
          name
          value
        }
        product {
          handle
          title
        }
        availableForSale
        sku
        title
        unitPrice {
          amount
          currencyCode
        }
      }
    }
  }
`;

export const PREVIEW_CARD_FRAGMENT = `#graphql
  fragment ProductCard on Product {
    id
    title
    vendor
    handle
    descriptionHtml
    options {
      name
      values
    }
    media(first: 3) {
      nodes {
        ...Media
      }
    }
    variants(first: 20) {
      nodes {
        id
        image {
          url
          altText
          width
          height
          id
        }
        price {
          amount
          currencyCode
        }
        compareAtPrice {
          amount
          currencyCode
        }
        selectedOptions {
          name
          value
        }
        product {
          handle
          title
        }
        availableForSale
        sku
        title
        unitPrice {
          amount
          currencyCode
        }
      }
    }
  }
`;

export const CART_FRAGMENT = `#graphql
fragment CartFragment on Cart {
  id
  checkoutUrl
  totalQuantity
  buyerIdentity {
    countryCode
    customer {
      id
      email
      firstName
      lastName
      displayName
    }
    email
    phone
  }
  lines(first: 100) {
    edges {
      node {
        id
        quantity
        attributes {
          key
          value
        }
        cost {
          totalAmount {
            amount
            currencyCode
          }
          amountPerQuantity {
            amount
            currencyCode
          }
          compareAtAmountPerQuantity {
            amount
            currencyCode
          }
        }
        merchandise {
          ... on ProductVariant {
            id
            availableForSale
            compareAtPrice {
              ...MoneyFragment
            }
            price {
              ...MoneyFragment
            }
            requiresShipping
            title
            image {
              ...ImageFragment
            }
            product {
              handle
              title
              id
            }
            selectedOptions {
              name
              value
            }
          }
        }
      }
    }
  }
  cost {
    subtotalAmount {
      ...MoneyFragment
    }
    totalAmount {
      ...MoneyFragment
    }
    totalDutyAmount {
      ...MoneyFragment
    }
    totalTaxAmount {
      ...MoneyFragment
    }
  }
  note
  attributes {
    key
    value
  }
  discountCodes {
    code
  }
}
`;

export const MONEY_FRAGMENT = `#graphql
fragment MoneyFragment on MoneyV2 {
  currencyCode
  amount
}
`;

export const IMAGE_FRAGMENT = `#graphql
fragment ImageFragment on Image {
  id
  url
  altText
  width
  height
}`;

export const PRODUCT_IMAGE_FRAGMENT = `#graphql
  fragment ProductImage on Product {
    id
    handle
    media(first: 1) {
      nodes {
        ...Media
      }
    }
    variants(first: 1) {
      nodes {
        id        
        image {
          url
          altText
          width
          height
          id
        }
      }
    }
  }
`;
